module.exports = __webpack_public_path__ + "img/module1_icon4.44358818.png";